import React, { Component } from 'react'
import Validators from '../../utilities/validators'
import ClickableIcon from '../ClickableIcon'

class NumberInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      listenForErrors: false
    }
  }

  render = () => {
    const {
      label,
      value,
      validate,
      onChange,
      placeholder,
      errorMessage,
      isValid,
      isParentModal,
      showButton,
      buttonLabel,
      onButtonClick,
      minimumValue = '0',
      idName,
      readOnly,
      onInfoButtonClick,
      isVerifyAccount,
      maximumValue = '9999999'
    } = this.props
    const { listenForErrors } = this.state

    const handleOnChange = (event) => {
      let { value, min, max } = event.target;

      if (parseFloat(min) > parseFloat(value) || parseFloat(max) < parseFloat(value)) return

      !Validators.containsSpecialCharacter(value, '-') &&
        onChange(event) && Validators.isValueInRange(value, min, max)
    }

    return (
      <>
        <div className='number-input-parent-wrapper'>
          <p className={`${isVerifyAccount ? 'number-input-label-verify-account-text' : 'number-input-label-text'} ${onInfoButtonClick && 'number-input-label-text-wrapper'}`}>
            {label}
            {onInfoButtonClick && <span style={{ marginLeft: 10 }}> <ClickableIcon onClick={onInfoButtonClick} /></span>}
            {showButton && <button
              onClick={onButtonClick}
              className="number-input-text-button"
              id={idName ? `${idName}-button` : ''}
            >
              {buttonLabel}
            </button>}
          </p>
          <div className={`number-input-wrapper ${isValid ? 'text-input-wrapper--is-valid' : listenForErrors && errorMessage ? 'text-input-wrapper--is-invalid' : ''}`}>
            <input
              readOnly={readOnly}
              className={`number-input number-input-is-text-centered number-input--is-rounded ${readOnly ? 'number-input--is-disabled' : ''}`}
              type="number"
              min={minimumValue}
              max={maximumValue}
              value={value}
              validate={validate}
              onChange={(event) => {
                isParentModal && this.setState({ listenForErrors: true })
                handleOnChange(event)
              }}
              onBlur={() => {
                !isParentModal && this.setState({ listenForErrors: true })
              }}
              onKeyDown={event => {
                if (event.key === '-') {
                  event.preventDefault();
                }
              }}
              placeholder={placeholder}
              id={idName ?? ''}
            />
          </div>
        </div>
        {listenForErrors && <p className="form-input-error-message">{isValid ? '' : errorMessage}</p>}
      </>
    )
  }
}

export default NumberInput